import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon20 } from 'builder/components/Icon'

export const Conatiner = styled.div`
  gap: 20px;
  display: flex;
  flex-direction: column;
  height: inherit;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid ${Colors.Neutral15};
  cursor: pointer;
  background-color: ${Colors.White};

  &:hover {
    border-color: ${Colors.Blue50};
  }

  ${Media.Phone`
    padding: 20px;
  `}
`

export const HeaderContainer = styled.div<{ $hasLabel?: boolean }>`
  display: flex;
  justify-content: space-between;

  ${({ $hasLabel }) =>
    $hasLabel &&
    Media.Phone`
      gap: 6px;
      flex-direction: column-reverse;
    `}
`

export const TextContainer = styled.div`
  gap: 4px;
  max-width: 303px;
  display: flex;
  flex-direction: column;

  ${Media.Phone`
    max-width: 250px;
  `}
`

export const ToggleContainer = styled.div<{ $hasLabel?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;

  ${({ $hasLabel }) =>
    $hasLabel &&
    Media.Phone`
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    `}
`

export const Label = styled.span`
  width: 87px;
  height: 50px;
  padding: 4px 8px 4px 12px;
  border-radius: 4px;
  background: linear-gradient(94deg, #37d274 0%, #0fcf5c 47.53%, #1ce58b 100%), #eaf6ff;

  color: ${Colors.White};
  ${Typography.Caption}
  ${FontWeights.DemiBold}

  ${Media.Phone`
    width: unset;
    height: unset;
    padding: 4px 8px;
  `}
`

export const IconContainer = styled.div``
export const Header = styled.h2`
  color: ${Colors.Neutral90};

  ${Typography.Subhead}
  ${FontWeights.DemiBold}
`

export const Description = styled.p`
  color: ${Colors.Neutral50};

  ${Typography.Body}
  ${FontWeights.Regular}
`

export const FeaturesContainer = styled.div<{ $addPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ $addPadding }) => $addPadding && `padding-right: 24px;`}
`

export const FeatureTitle = styled.h3`
  color: #303848;
  ${Typography.Caps}
  ${FontWeights.DemiBold}
  text-transform: uppercase;
`

export const Features = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

export const Feature = styled.div`
  display: flex;
  gap: 4px;
`

export const FeatureText = styled.span`
  color: ${Colors.Neutral90};

  ${Typography.Caption}
  ${FontWeights.Regular}

  span {
    ${FontWeights.Medium}
  }
`
export const FeatureIconContainer = styled.div``
export const FeatureIcon = styled(Icon20.Tick)`
  color: ${Colors.Blue50};
`

export const FooterContainer = styled.div`
  margin-top: auto;
  margin-right: -10px;

  ${Media.Phone`
    margin-right: 0;
  `}
`

export const FooterText = styled.div`
  color: ${Colors.Neutral50};

  ${Typography.Caption}
  ${FontWeights.Regular}
`
